import { IconComponentType, IconWrapper } from './icon-wrapper'

const IconBack: IconComponentType = ({ className }) => {
  return (
    <IconWrapper className={className}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.0008 4.99877C21.266 4.99877 21.5204 5.10412 21.7079 5.29166C21.8954 5.47919 22.0008 5.73355 22.0008 5.99877L22.0008 11.9993C22.0008 12.2645 21.8954 12.5189 21.7079 12.7064C21.5204 12.894 21.266 12.9993 21.0008 12.9993L5.41454 12.9993L9.70829 17.2918C9.89593 17.4795 10.0013 17.734 10.0013 17.9993C10.0013 18.2647 9.89593 18.5192 9.70829 18.7068C9.52065 18.8945 9.26615 18.9999 9.00079 18.9999C8.73542 18.9999 8.48093 18.8945 8.29329 18.7068L2.29329 12.7068C2.20031 12.6139 2.12655 12.5037 2.07623 12.3823C2.0259 12.2609 2 12.1307 2 11.9993C2 11.8679 2.0259 11.7378 2.07623 11.6164C2.12655 11.495 2.20031 11.3847 2.29329 11.2918L8.29329 5.29182C8.48093 5.10418 8.73542 4.99876 9.00079 4.99876C9.26615 4.99876 9.52065 5.10418 9.70829 5.29182C9.89593 5.47946 10.0013 5.73396 10.0013 5.99932C10.0013 6.26469 9.89593 6.51918 9.70829 6.70682L5.41454 10.9993L20.0008 10.9993L20.0008 5.99877C20.0008 5.73355 20.1061 5.47919 20.2937 5.29166C20.4812 5.10412 20.7356 4.99877 21.0008 4.99877Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  )
}

export default IconBack